import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export interface IwrapperProps {
  children: React.ReactNode;
}

const Wrapper: React.FC<IwrapperProps> = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Wrapper;
